<template>
    <div>
        <JqxWindow ref="myWindow" :theme="'material'" :width="1900" :height="600" :resizable="true" :isModal="true"
                   :autoOpen="false" :initContent="init" @open="myWindowOnOpen()" @close="myWindowOnClose()">
            <div class="col-md"><strong>Ingresso</strong>
            </div>
            <div>
                <JqxTabs ref="tab" :theme="'material'" :animationType="'fade'" :autoCreate="false"
                         @tabclick="onTabClick($event)">
                    <ul style="margin-left: 5px">
                        <li>Dati generali</li>
                        <li>Corpo ingresso</li>
                    </ul>
                    <div>
                        <div class="form-group">
                            <label>Impianto depositante</label>
                            <br>
                            <JqxComboBox :autoDropDownHeight="true" ref="impianto_depositante"
                                         :popupZIndex="10000" :displayMember="'ragione_sociale'"
                                         :valueMember="'id'"
                                         :source="dataAdapterImpianti" :theme="'material'"
                                         @close="onClose($event)"></JqxComboBox>
                        </div>
                        <div class="form-group">
                            <label>Data arrivo merce</label>
                            <br>
                            <JqxDateTimeInput :formatString="'yyyy-MM-dd'" :theme="'material'" ref="data_arrivo_merce"></JqxDateTimeInput>
                        </div>

                        <div class="form-group">
                            <label>Data documento fornitore *</label>
                            <br>
                            <JqxDateTimeInput :formatString="'yyyy-MM-dd'" :theme="'material'" ref="data_documento_fornitore"></JqxDateTimeInput>
                        </div>

                        <div class="form-group">
                            <label>Documento fornitore *</label>
                            <br>
                            <JqxInput :theme="'material'" ref="documento_fornitore"></JqxInput>
                        </div>
                    </div>
                    <div>
                        <JqxDetailsIngressiUscite ref="DetailsIngressiUscite"></JqxDetailsIngressiUscite>
                    </div>
                </JqxTabs>
                <card>
                    <div class="float-right">
<!--                        <JqxButton :theme="'material'" @click="saveParent">-->
                        <JqxButton ref="save" :theme="'material'" @click="waitSave" >
                            Save
                        </JqxButton>

                        <JqxButton :theme="'material'" @click="cancelParent">
                            Cancel
                        </JqxButton>
                    </div>
                </card>
            </div>
        </JqxWindow>
    </div>
</template>

<script>
    import JqxWindow from "~jqx/jqwidgets-vue/vue_jqxwindow.vue";
    import JqxButton from "~jqx/jqwidgets-vue/vue_jqxbuttons.vue";
    import JqxInput from "~jqx/jqwidgets-vue/vue_jqxinput.vue";
    import JqxNumberInput from "~jqx/jqwidgets-vue/vue_jqxnumberinput.vue";
    import JqxSplitter from '~jqx/jqwidgets-vue/vue_jqxsplitter.vue';
    import JqxComboBox from "~jqx/jqwidgets-vue/vue_jqxcombobox.vue";
    import JqxDateTimeInput from "~jqx/jqwidgets-vue/vue_jqxdatetimeinput.vue";
    import JqxGrid from "~jqx/jqwidgets-vue/vue_jqxgrid.vue";
    import JqxTabs from '~jqx/jqwidgets-vue/vue_jqxtabs.vue';
    import JqxDetailsIngressiUscite from "./JqxDetailsIngressiUscite";

    export default {
        name: "IngressiDetails",
        components: {
            JqxDetailsIngressiUscite,
            JqxInput,
            JqxNumberInput,
            JqxButton,
            JqxWindow,
            JqxSplitter,
            JqxComboBox,
            JqxDateTimeInput,
            JqxGrid,
            JqxTabs
        },
        data: function () {
            return {
                panels: [{size: 200}, {size: 200}],
                dataAdapterImpianti: new jqx.dataAdapter(this.sourceanagraficaimpianti),
                checkEmptyGrid: 0,
            }
        },
        beforeCreate: function () {
            this.sourceanagraficaimpianti = {
                datatype: 'json',
                datafields: [
                    {name: 'ragione_sociale'},
                    {name: 'id'},
                ],
                url: '/api/cruds/read?t=AnagraficaImpianti&q=allforsourceinput'
            };
        },
        methods: {
            onTabClick: function (tab) {
                switch (tab.args.item) {
                    case 0:

                        break;
                    case 1:
                        this.checkEmptyGrid = 1;
                        this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.dataCreationCustomDetails();
                        break;
                }
            },

            waitSave(){
                this.$refs.save.setOptions({disabled: true});
                setTimeout(() => this.saveParent(), 300);
            },
            saveParent() {
                let data = this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.getvalori();
                //console.log('data: ', data);
                let empty_check = data.some((el)=>{
                    // let empty = Object.values(el).some((el2)=>{return (el2 === null || el2 === "")});
                    // let length = Object.values(el).length;
                    // //console.log("el: ", el);
                    // //console.log("el lenght: ", length);
                    let empty = false;
                    if(!el.articolo_id || !el.descrizione_articolo_id || !el.unita_di_misura || !el.quantita_dichiarata) {
                        empty = true;
                    }
                    return (empty);
                });
                if(this.checkEmptyGrid === 1 && data.length < 1){
                    alert('Attenzione! Non è stato inserito alcun articolo all\'interno del corpo dell\'ingresso. Correggere per continuare.');
                } else if(this.checkEmptyGrid === 1 && empty_check) {
                    alert('Attenzione! Uno o più articoli all\'interno del corpo dell\'ingresso non sono completi. Correggere per continuare.');
                } else {
                    this.$parent.saveBtn(data);
                }
                this.$refs.save.setOptions({disabled: false});
            },
            cancelParent() {
                this.$parent.cancelBtn();
            },
            onClose: function (event) {
                // this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.setQueryModel('/api/cruds/read?t=GestioneIngressiCorpo&q=impianto_depositante-' + this.$refs.impianto_depositante.val());
                this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.setImpianto(this.$refs.impianto_depositante.val());
                // this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.dataCreationCustomDetails();
            },
            init: function () {
                let options = {height: "80%", theme: "material"};
                this.$refs.tab.createComponent(options);
                this.reorderColum();
            },
            myWindowOnOpen: function () {
                if (this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.getvalori()) {
                    this.$refs.DetailsIngressiUscite.$refs.myGridDetails.clear();
                }
                let impianto = this.$refs.impianto_depositante.getSelectedIndex() != -1 ? this.$refs.impianto_depositante.getSelectedIndex() : 0;
                this.$refs.impianto_depositante.selectIndex(impianto);
                this.onClose();
            },
            myWindowOnClose: function () {
                this.$refs.DetailsIngressiUscite.$refs.myGridDetails.$parent.resetGrid();
            },
            setDateCustom: function () {
                this.$refs.data_arrivo_merce.setDate(new Date());
            },
            newRowCheckGrid: function (isNew) {
                this.checkEmptyGrid = isNew;
            },
            reorderColum: function () {
                //Imposto ordine colonne da front-end
                // try {
                //     if (this.$refs.tab.val() === 0) {
                //         this.$refs.DetailsIngressiUscite.$refs.myGridDetails.setcolumnindex('articolo', 0);
                //         this.$refs.DetailsIngressiUscite.$refs.myGridDetails.setcolumnindex('descrizione_articolo_id', 1);
                //         // this.$refs.myGridDetails.setcolumnindex('quantita_dichiarata', 5);
                //     }
                // } catch (err) {
                //
                // }
            }
        }
    }
</script>

<style scoped>
    .jqx-splitter {
        border: none;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/cruddetails/IngressiDetails.vue